import { createContext, Dispatch, SetStateAction } from 'react'

interface ILoadingActionContext {
    setLoading: (key: string) => void;
    setComplete: (key: string) => void;
    setValidating: (key: string) => void;
    setValid: (key: string) => void;
}

export const LoadingActionContext = createContext<ILoadingActionContext>({
    setComplete: (key) => {},
    setLoading: (key) => {},
    setValidating: (key) => {},
    setValid: (key) => {}
});

export default LoadingActionContext;